import React, {useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import Header from './Header.jsx';           // ваш компонент шапки
import malinaImg from '../images/malina_compressed.png'; // пример картинки
import '../style/CakeDetail.css';

const CakeDetailRasp = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const navigate = useNavigate();

  return (
    <>
      <Header />

      <div className="detail-container">
        <div className="detail-text">
          <h2>Наполеон с малиной</h2>
          <p>Натуральный ягодный конфи придаст торту новый необычный вкус.</p>
          <p><strong>Вес:</strong> 1,4&nbsp;кг</p>
          <p><strong>Цена:</strong> 2500&nbsp;₽</p>
          <button onClick={() => navigate(-1)} className="back-button">
            ← Назад
          </button>
        </div>

        <div className="detail-image">
          <img src={malinaImg} alt="Наполеон Классический" />
        </div>
      </div>
    </>
  );
};

export default CakeDetailRasp;
